import { NumberInput, NumberInputProps, useTranslate } from 'react-admin';
import { Box, InputLabel } from '@mui/material';

export const GrayNumberInputWithUpperLabel = (props: NumberInputProps & { isRequired?: boolean }) => {

  const translate = useTranslate();

  return (
    <Box display="flex" flexDirection="column">
      {props.label !== false && (
        <InputLabel className="input-label" required={props.isRequired}>
          {translate(typeof props.label === 'string' ? props.label : '', { _: props.label })}
        </InputLabel>
      )}
      <NumberInput
        {...props}
        label={false}
        inputProps={{
          ...props.inputProps,
          style: {
            backgroundColor: '#f1f1f1',
            borderRadius: '5px',
            ...props.inputProps?.style,
          },
        }}
        sx={{
          mt: 0,
          mb: 0,
          ...props.sx,
          '& fieldset': {
            border: 'none',
          },
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#f1f1f1 !important',
            boxSizing: 'border-box',
            minHeight: props.size === 'small' ? 40 : 56,
            height: props.size === 'small' ? 40 : 56,
            alignItems: 'center',
          },
        }}
      />
    </Box>
  );

};
